import React from 'react';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Modal } from '/imports/ui/Modal';

// Old styled(Modal) block; its rules target descendants Modal renders, so they
// ride on Modal's className via [&_.x]: arbitrary variants.
// This one supplies its buttons as children rather than through Modal's
// `buttons` prop, so it styles its own action row to sit like the footer band.
const confirmModalClassName = [
  '[&_.modal-window]:min-w-[min(26rem,90vw)]',
  '[&_.message]:pb-4 [&_.message]:text-[13px] [&_.message]:text-fg-2',
  '[&_.option-buttons]:flex [&_.option-buttons]:justify-end [&_.option-buttons]:gap-2',
  '[&_input]:mr-4 [&_input]:inline-block [&_input]:w-auto',
].join(' ');

interface ConfirmModalProps {
  title?: string;
  body?: string | React.ReactNode;
  onClose(): void;
  onConfirm(): void;
  confirmText?: string;
  rejectText?: string;
}

export const ConfirmModal = (props: ConfirmModalProps) => {
  return (
    <Modal
      className={confirmModalClassName}
      title={props.title || ''}
      onClose={props.onClose}
    >
      <div className="message">{props.body || ''}</div>
      <div className="option-buttons">
        <Button id="confirm-yes" className="primary" onClick={() => props.onConfirm()}>{props.confirmText || strings.Yes()}</Button>
        <Button id="confirm-no" className="secondary" onClick={() => props.onClose()}>{props.rejectText || strings.No()}</Button>
      </div>
    </Modal>
  );
};